// extracted by mini-css-extract-plugin
export default {"root":"UserInfoForm_root__83F6K","card":"UserInfoForm_card__YLvkm","infoCard":"UserInfoForm_infoCard__-Oek8","label":"UserInfoForm_label__MZy8L"};